import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { SUB_BU_QUERY_OPTIONS } from '../constants/QueryConstants';

/**
 * Fetches Squad options ("SBU | Squad") for the selected BUs/Sub-BUs via /dashboard/squads.
 * Cascades off Business Unit + Sub-BU + Delivery Manager (email).
 * Returns empty list and no loading when businessUnits is empty or undefined.
 */
export function useSquadsOptions(
  businessUnits: string[] | undefined,
  subBus: string[] | undefined,
  deliveryManagers: string[] | undefined
) {
  const { user } = useAuth();
  const enabled = !!(businessUnits && businessUnits.length > 0);

  const result = useQuery({
    queryKey: ['squad-options', user?.id, businessUnits, subBus, deliveryManagers],
    queryFn: async () => {
      if (!businessUnits || businessUnits.length === 0) return [];
      return dashboardApi.getSquads(businessUnits, subBus ?? [], deliveryManagers ?? []);
    },
    enabled,
    ...SUB_BU_QUERY_OPTIONS,
  });

  return {
    data: result.data ?? [],
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch,
  };
}
